module.exports = __webpack_public_path__ + "img/2-place-medal-simple.a6b64d6f.svg";